import { ApolloProvider } from '@apollo/client';
import React from 'react';
import { Language } from '@peloton/internationalize/models/language';

import { toLocale } from '@peloton/internationalize/models/locale';
import { useApolloAuthClient } from '@auth/client/useApolloAuthClient';
import { useReduxState } from '@engage/redux/hooks';
import { getDisplayLanguage } from '@engage/settings/redux';
import { toClient } from './client';

export const GraphqlProvider: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const language = useReduxState(getDisplayLanguage);
  const client = toClient({
    headers: {
      'Accept-Language': toLocale(language ?? Language.English),
    },
  });

  // Single source-of-truth attach logic shared with @auth/client and
  // @studio/api: Auth0 token → checkout token → withCredentials cookie
  // fallback, spliced onto this existing Apollo client's link chain instead
  // of building a net-new client (preserves the module-scoped InMemoryCache
  // in @engage/graphql/client.ts).
  useApolloAuthClient({ existingClient: client });

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
